<!--
  入金任务规则弹窗
  素材：dialog/balloon.png 气球、dialog/icon-deposit.png 钱包、
  dialog/deco-underline.png 标题笔画、dialog/deco-star.png 小星星（旋转摆放）
-->
<script lang="ts">
  import { _ as t } from "svelte-i18n";
  import BottomSheet from "./BottomSheet.svelte";
  import balloon from "../assets/images/dialog/balloon.png";
  import walletIcon from "../assets/images/dialog/icon-deposit.png";
  import underline from "../assets/images/dialog/deco-underline.png";
  import star from "../assets/images/dialog/deco-star.png";

  interface Props {
    show: boolean;
    onClose: () => void;
  }

  let { show, onClose }: Props = $props();

  // 档位：文案放 i18n，序号在这里
  const tiers = [1, 2, 3];
</script>

<BottomSheet {show} {onClose}>
  <!-- 气球：压在弹窗左上角并向上溢出 -->
  <img src={balloon} alt="" class="dlg-balloon" />

  <!-- 标题：入金（金色）+ 任务规则（白色），下方蓝色笔画，右上小星星 -->
  <div class="dlg-title-wrap">
    <h2 class="dlg-title">
      <span class="dlg-title-hl">{$t("deposit_rule_title_hl")}</span
      >{$t("deposit_rule_title")}
    </h2>
    <img src={underline} alt="" class="dlg-title-line" />
    <!-- 两颗小星星：右上一颗、「入金」左下一颗 -->
    <img src={star} alt="" class="dlg-title-star is-right" />
    <img src={star} alt="" class="dlg-title-star is-left" />
  </div>

  <!-- 白色内容卡 -->
  <div class="dlg-card">
    <img src={walletIcon} alt="" class="dlg-wallet" />

    <p class="dlg-card-title">{$t("guide_title")}</p>

    <div class="dlg-table">
      <!-- 用 CSS table 布局，保证多行的列宽一致（右列文案长短不一） -->
      <div class="dlg-table-inner">
        {#each tiers as n (n)}
          <div class="dlg-row">
            <span class="dlg-cell-left">
              <span class="dlg-cell-text">{$t(`deposit_tier_${n}`)}</span>
            </span>
            <span class="dlg-cell-right">
              <span class="dlg-cell-text">{$t(`deposit_tier_${n}_code`)}</span>
            </span>
          </div>
        {/each}
      </div>
    </div>

    <p class="dlg-max">{$t("deposit_max")}</p>
    <p class="dlg-note">{$t("deposit_note")}</p>
  </div>

  <button type="button" class="grad-btn dlg-confirm" onclick={onClose}>
    {$t("btn_confirm")}
  </button>
</BottomSheet>

<style>
  /* 气球 152x258@2x = 76x129，向上溢出弹窗顶边 */
  .dlg-balloon {
    position: absolute;
    top: -26px;
    left: -4px;
    width: 76px;
    height: 129px;
  }

  /* 顶部间距由弹窗的 padding-top 26px 提供，这里只留标题到白卡的距离 */
  .dlg-title-wrap {
    position: relative;
    padding-bottom: 6px;
    text-align: center;
  }

  /* 标题（设计稿）：20px / 700 / line-height 20px / shadow 0 2px 2px #165BFD */
  .dlg-title {
    position: relative;
    z-index: 1;
    font-size: 20px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0;
    color: #ffffff;
    text-shadow: 0 2px 2px #165bfd;
  }

  /* 高亮部分「入金」：#FFDF00 */
  .dlg-title-hl {
    color: #ffdf00;
  }

  /* 标题笔画 149x18@2x = 74.5x9，压在标题右下方 */
  .dlg-title-line {
    position: absolute;
    bottom: -6px;
    left: 50%;
    width: 74.5px;
    height: 9px;
    margin-left: 7px;
  }

  /* 小星星 16x16@2x = 8x8，两颗都相对标题中心偏移，各自旋转一个角度 */
  .dlg-title-star {
    position: absolute;
    left: 50%;
    width: 8px;
    height: 8px;
  }

  /* 右上：「规则」右侧 */
  .dlg-title-star.is-right {
    top: -2px;
    margin-left: 82px;
    transform: rotate(-20deg);
  }

  /* 左下：「入金」左侧偏下 */
  .dlg-title-star.is-left {
    top: 21px;
    margin-left: -91px;
    transform: rotate(15deg);
  }

  .dlg-card {
    position: relative;
    margin-top: 15px;
    padding: 12px;
    border-radius: 16px;
    background: #ffffff;
  }

  /* 钱包 83x63，压在白卡右上角 */
  .dlg-wallet {
    position: absolute;
    top: -13px;
    right: 8px;
    width: 83px;
    height: 63px;
  }

  /* 获取攻略（设计稿）：16px / 600 / line-height 24px / #003EC7 */
  .dlg-card-title {
    position: relative;
    z-index: 1;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
    color: #003ec7;
  }

  /* 表格：底色 #F3FAFF，边框统一 #ABDEFF */
  .dlg-table {
    margin-top: 12px;
    border: 1px solid #abdeff;
    border-radius: 8px;
    background: #f3faff;
    overflow: hidden;
  }

  .dlg-table-inner {
    display: table;
    width: 100%;
  }

  .dlg-row {
    display: table-row;
  }

  /* 单元格都垂直居中 */
  .dlg-cell-left,
  .dlg-cell-right {
    display: table-cell;
    vertical-align: middle;
  }

  /* 行分隔线画在单元格上（table-row 的 border 不一定绘制） */
  .dlg-row:not(:first-child) .dlg-cell-left,
  .dlg-row:not(:first-child) .dlg-cell-right {
    border-top: 1px solid #abdeff;
  }

  /* 左列：固定 229px，只设上下 9px */
  .dlg-cell-left {
    width: 229px;
    padding: 9px 0;
  }

  .dlg-cell-left .dlg-cell-text {
    text-align: center;
  }

  /* 右列：占满剩余宽度，只设上下 9px，不换行 */
  .dlg-cell-right {
    padding: 9px 0;
    border-left: 1px solid #abdeff;
    white-space: nowrap;
  }

  /*
    表格文字（设计稿）：14px / 400 / line-height 22px / #001746
    单独一层撑满宽度，换行后每一行都能水平居中
  */
  .dlg-cell-text {
    /* span 默认是行内元素，width / text-align 不生效，这里转成块级 */
    display: block;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0;
    color: #001746;
    text-align: center;
  }

  .dlg-max {
    margin-top: 12px;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: #001746;
  }

  /* 备注（设计稿）：14px / 400 / line-height 150% / #001746 */
  .dlg-note {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0;
    color: #001746;
    text-align: justify;
    text-justify: inter-ideograph;
  }

  /* 渐变底 + 1.5px 渐变描边 + 内阴影同任务按钮，见 app.css 的 .grad-btn */
  .dlg-confirm {
    width: 100%;
    height: 48px;
    margin-top: 24px;
    border-radius: 24px;
    font-size: 16px;
    font-weight: 600;
    line-height: 1;
  }
</style>
